<template>
  <div class="ecommerce-page">
    <div class="ecommerce-coverpage">
      <div class="ecommerce-modal" :style="{ top: modalTop }">
        <div class="ecommerce-title">
          <el-row style="padding: 5px 2px; text-align: left; font-weight: 500">
            <h1>Agregar nueva dirección</h1>
          </el-row>
        </div>

        <div class="ecommerce-searcher">
          <div id="buscador" class="box">
            <el-row>
              <el-col>
                <el-autocomplete
                  ref="autocomplete"
                  class="inline-input"
                  v-model="address"
                  :fetch-suggestions="querySearch"
                  placeholder="Ingresa una dirección"
                  @select="handleSelect"
                  @clear="clearAutocomplete"
                  clearable
                >
                  <i class="el-icon-search el-input__icon" slot="prefix"> </i>
                  <template slot-scope="{ item }">
                    <div
                      :class="
                        item.code == 'geolocation'
                          ? 'geo-d'
                          : item.code == 'none'
                          ? 'none-d'
                          : ''
                      "
                    >
                      {{ item.description }}
                    </div>
                    <span
                      :class="
                        item.code == 'geolocation'
                          ? 'geo-l'
                          : item.code == 'none'
                          ? 'none-l'
                          : ''
                      "
                      >{{ item.link }}</span
                    >
                  </template>
                  <input value="uno" />
                </el-autocomplete>
              </el-col>
            </el-row>
          </div>

          <div id="map" class="stack-top" :style="{ height: mapHeight }"></div>
        </div>

        <div id="addressSegments" class="ecommerce-result">
          <el-row style="padding: 5px 0px">
            <el-col :span="10" style="padding: 0px 5px">
              <el-input
                placeholder="Via"
                v-model="via"
                :disabled="true"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="4" style="padding: 0px 5px">
              <el-input placeholder="Puerta" v-model="numbervia" clearable>
              </el-input>
            </el-col>
            <el-col :span="4" style="padding: 0px 5px">
              <el-input placeholder="Dpto" v-model="dpto" clearable> </el-input>
            </el-col>
            <el-col :span="6" style="padding: 0px 5px">
              <el-input
                placeholder="Distrito"
                v-model="distrito"
                :disabled="true"
                clearable
              >
              </el-input>
            </el-col>
          </el-row>
          <el-row style="padding: 5px 0px">
            <el-col :span="8" style="padding: 0px 5px">
              <el-input
                placeholder="Urbanizacion"
                v-model="sublocality"
                :disabled="true"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="4" style="padding: 0px 5px">
              <el-input placeholder="Manzana" v-model="manzana" clearable>
              </el-input>
            </el-col>
            <el-col :span="4" style="padding: 0px 5px">
              <el-input placeholder="Lote" v-model="lote" clearable> </el-input>
            </el-col>
          </el-row>

          <el-row style="padding: 5px 0px">
            <el-col :span="24" style="padding: 0px 5px">
              <label style="color: #737373"
                >Referencia:
                <el-input
                  placeholder="Ejm: Entre Av. Alfonso Ugarte y Av. Venezuela"
                  v-model="reference"
                  clearable
                >
                </el-input>
              </label>
            </el-col>
          </el-row>
          <!--<el-row style="padding: 5px 0px;">
						<el-col :span="24" style="padding: 0px 5px;float: right;">
							<el-button type="primary" @click="enviar" round>Enviar</el-button>
						</el-col>
					</el-row>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import L from "leaflet";

export default {
  data() {
    return {
      map: null,
      zoom: {},
      controlLayers: {},
      marker: null,
      token: "e06bc536-47da-46d7-a795-b12bb1aa1141",
      address: "",
      via: "",
      numbervia: "",
      dpto: "",
      distrito: "",
      sublocality: "",
      manzana: "",
      reference: "",
      lote: "",
      owner: "",
      modalTop: "26%",
      mapHeight: "110px",
    };
  },
  mounted() {
    this.$refs.autocomplete.focus();
    this.initMap();
  },
  methods: {
    initMap() {
      this.map = L.map("map", {
        center: [-12.12, -77.02],
        zoom: 13,
        minZoom: 1,
        maxZoom: 20,
        scaleControl: false,
        zoomControl: false,
        attributionControl: true,
      });

      const geodirStreets = L.tileLayer(
        "https://tiles.geodir.co/osm_tiles/{z}/{x}/{y}.png",
        {
          minZoom: 1,
          maxZoom: 20,
          attribution:
            '&copy; <a href="https://maps.geodir.co/" target="_blank">Geodir Maps</a> Contribuciones',
        }
      ).addTo(this.map);

      const googleSatellite = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        {
          minZoom: 1,
          maxZoom: 20,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      );

      const baseMaps = {
        "Geodir Calles": geodirStreets,
        "Google Satélite": googleSatellite,
      };
      // CONTROL ESCALA
      const scale = L.control
        .scale({
          imperial: false,
        })
        .addTo(this.map);

      //CONTROL ZOOM
      this.zoom = L.control.zoom({ position: "bottomright" });

      // CONTROL CAPAS
      this.controlLayers = L.control.layers(baseMaps);

      // CONTROL FULLSCREEN
      /*var fsControl = new L.Control.FullScreen({ position: 'bottomright' });
				this.map.addControl(fsControl);
				this.map.on('enterFullscreen', function () {
					if (window.console) window.console.log('enterFullscreen');
				});
				this.map.on('exitFullscreen', function () {
					if (window.console) window.console.log('exitFullscreen');
				});*/
    },
    getCoordinatesOfUser() {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      var that = this;
      function success(e) {
        localStorage.setItem("longitude", e.coords.longitude);
        localStorage.setItem("latitude", e.coords.latitude);

        let latitud = e.coords.latitude;
        let longitud = e.coords.longitude;

        $.ajax({
          url:
            "https://apis.geodir.co/geocoding/v1/json?latlon=" +
            latitud +
            "," +
            longitud +
            "&key=" +
            that.token,
          success: function (respuesta) {
            //console.log('reverse respuesta');
            //console.log(respuesta);
            //that.adressSelected = respuesta.results[0].standard_address;
            if (respuesta.status == "OK") {
              let firstResult = respuesta.results[0];
              let address = firstResult.standard_address;
              that.address = address;

              that.getInformation(firstResult, that);
              that.printMarker(latitud, longitud, address, that);
              that.map.invalidateSize();
              that.map.addControl(that.zoom);
              that.map.addControl(that.controlLayers);
              that.map.flyTo([latitud, longitud], 16);
            } else {
              console.log("fallo reverse");
            }
          },
          error: function () {
            console.log("No se ha podido obtener la información");
          },
        });
      }

      function error(err) {
        localStorage.clear();
      }

      /*if (this.detectMobile()) {
					console.log('es movil');
					navigator.geolocation.getCurrentPosition(success, error, options);
				}else{
					console.log('no es movil');
					navigator.geolocation.getCurrentPosition(success, error, options);
				}*/

      navigator.geolocation.getCurrentPosition(success, error, options);

      //console.log('Coordenadas obtenidas');
      //console.log(localStorage.getItem("latitude"));
      //console.log(localStorage.getItem("longitude"));
    },
    detectMobile() {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        return true;
      } else {
        return false;
      }
    },
    querySearch(queryString, cb) {
      let predictions = [];

      if (queryString == "") {
        let item = {
          description:
            "Si no encuentras tu dirección, prueba buscando primero tu provincia",
          code: "none",
        };
        predictions.push(item);

        if (localStorage.getItem("latitude")) {
          let geolocation = {
            description: "Ubicación actual",
            code: "geolocation",
          };
          predictions.push(geolocation);
        } else {
          let geolocation = {
            description: "Ubicación actual",
            code: "geolocation",
            link: "Ubicación no disponible - Activar geolocalización",
          };
          predictions.push(geolocation);
        }

        cb(predictions);
      } else {
        $.ajax({
          url:
            "https://apis.geodir.co/places/autocomplete/v1/json?search=" +
            queryString +
            "&key=" +
            this.token,
          success: function (respuesta) {
            //console.log('autocomplete respuesta');
            //console.log(respuesta)
            predictions = respuesta.predictions;
            cb(predictions);
          },
          error: function () {
            console.log("No se ha podido obtener la información");
          },
        });
      }
    },
    clearAutocomplete() {
      this.modalTop = "26%";
      this.mapHeight = "110px";
      this.map.removeControl(this.zoom);
      this.map.removeControl(this.controlLayers);
      this.$refs.autocomplete.focus();
      this.cleanSegments();
      this.cleanmarker();
    },
    handleSelect(addressSelected) {
      if (addressSelected.code == "none") {
        return;
      }

      if (addressSelected.code == "geolocation") {
        this.getCoordinatesOfUser();
      }

      this.modalTop = "15%";
      this.mapHeight = "330px";
      this.cleanmarker();

      let that = this;
      let place_id = addressSelected.place_id;

      this.cleanSegments();

      $.ajax({
        url:
          "https://apis.geodir.co/places/fields/v1/json?place_id=" +
          place_id +
          "&key=" +
          this.token,
        success: function (respuesta) {
          if (respuesta.status == "OK") {
            let latitud = respuesta.geometry.coordinates.lat;
            let longitud = respuesta.geometry.coordinates.lon;
            let address = respuesta.standard_address;
            that.address = address;
            that.getInformation(respuesta, that);
            that.printMarker(latitud, longitud, address, that);
            that.map.invalidateSize();
            that.map.addControl(that.zoom);
            that.map.addControl(that.controlLayers);
            that.map.flyTo([latitud, longitud], 16);
          }
        },
        error: function () {
          console.log("No se ha podido obtener la información");
        },
      });
    },
    printMarker(latitud, longitud, address, that) {
      var customIcon = new L.Icon({
        iconUrl: require("@/assets/img/resources/icon-marker.png"),
        iconSize: [28, 40],
        iconAnchor: [25, 50],
        popupAnchor: [0, -38],
      });

      that.marker = L.marker([latitud, longitud], {
        icon: customIcon,
        draggable: "true",
      }).addTo(that.map);

      that.marker.on("dragend", function (event) {
        var marker = event.target;
        var position = marker.getLatLng();
        marker.setLatLng(new L.LatLng(position.lat, position.lng), {
          draggable: "true",
        });
        that.map.panTo(new L.LatLng(position.lat, position.lng));
        marker.openPopup();

        //console.log(position.lat, position.lng);

        // Buscar en el servicio reverso
        //this.cleanSegments();

        $.ajax({
          url:
            "https://apis.geodir.co/geocoding/v1/json?latlon=" +
            position.lat +
            "," +
            position.lng +
            "&key=" +
            that.token,
          success: function (respuesta) {
            //console.log('reverse respuesta');
            //console.log(respuesta);
            //that.adressSelected = respuesta.results[0].standard_address;
            if (respuesta.status == "OK") {
              let firstResult = respuesta.results[0];
              that.getInformation(firstResult, that);

              that.address = firstResult.standard_address;

              //console.log('asignar popup');
              //that.marker.bindPopup(address).openPopup();
            } else {
              console.log("fallo reverse");
            }
          },
          error: function () {
            console.log("No se ha podido obtener la información");
          },
        });
      });
    },
    getInformation(firstResult) {
      const segments = {
        ROUTE: "route",
        ROUTE_TYPE: "route_type",
        ROUTE_NUMBER: "route_number",
        ADMIN_LEVEL_3: "admin_level_3",
        SUBLOCALITY: "sublocality",
        MANZANA: "manzana",
      };

      var namevia = "";
      var typeVia = "";
      for (let segment of firstResult.address_segments) {
        //console.log('segmento');
        //console.log(segment);
        let type = segment.types;

        if (type.includes(segments.ROUTE)) {
          namevia = segment.name;
        } else if (type.includes(segments.ROUTE_TYPE)) {
          typeVia = segment.name;
        } else if (type.includes(segments.ROUTE_NUMBER)) {
          this.numbervia = segment.name;
        } else if (type.includes(segments.ADMIN_LEVEL_3)) {
          this.distrito = segment.name;
        } else if (type.includes(segments.SUBLOCALITY)) {
          this.sublocality = segment.name;
        } else if (type.includes(segments.MANZANA)) {
          this.manzana = segment.name;
        }
        //console.log(typeVia);
        //console.log(namevia);
        if (namevia) {
          this.via = typeVia + " " + namevia;
        }
      }
    },
    cleanmarker() {
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }
    },
    cleanSegments() {
      this.via = "";
      this.numbervia = "";
      this.dpto = "";
      this.distrito = "";
      this.sublocality = "";
      this.manzana = "";
      this.reference = "";
      this.lote = "";
      this.address = "";
      this.owner = "";
    },
    enviar() {
      console.log("Datos de la direccion");
      console.log(this.via);
      console.log(this.numbervia);
    },
  },
};
</script>

<style scoped>
.ecommerce-page {
  margin-top: 70px;
}

.ecommerce-coverpage {
  width: 100%;
  height: 93vh;
  background-image: url("../../../src/assets/img/resources/ecommerce-portada.png");
  background-size: cover;
}

.ecommerce-modal {
  width: 678px;
  margin: auto;
  background-color: #ffffff;
  border: 1px solid #c2bebe;
  position: relative;
}

.ecommerce-title {
  margin: auto;
  max-width: 800px;
  padding: 10px;
  text-align: center;
  color: #000000;
  font-size: 21px;
}

.ecommerce-searcher {
  width: 678px;
  margin: auto;
  position: relative;
}

#map {
  max-width: 650px;
  margin: 0px 10px;
  padding: 0px;
  z-index: 5;
  border-radius: 4px;
}

.box {
  position: absolute;
  padding: 5px 16px;
  top: 0;
  left: 0;
  z-index: 10;
}

.el-autocomplete {
  width: 636px;
}

.ecommerce-result {
  max-width: 800px;
  margin: auto;
  padding: 10px;
}

.stack-top {
  z-index: 9;
  margin: 30px;
}

/* CONTROL FULLSCREEN */
.leaflet-control-zoom-fullscreen {
  background-image: url("../../assets/img/resources/icon-fullscreen.png");
}

/* SELECTOR CAPAS DE COBERTURA */
.leaflet-control-layers-selector[type="radio"] {
  margin: 4px 4px !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
  position: relative;
  background-color: #f1f1f1;
  color: #0a86ff;
  top: 10px;
  height: 20px;
  width: 20px;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  margin-right: 7px;
  outline: none;
}

.leaflet-control-layers-selector[type="checkbox"] {
  margin: 4px 4px !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
  position: relative;
  background-color: #f1f1f1;
  color: #0a86ff;
  top: 10px;
  height: 20px;
  width: 20px;
  border: 0;
  cursor: pointer;
  margin-right: 7px;
  outline: none;
}

.leaflet-control-layers-selector:checked::before {
  position: absolute;
  font: 11px/1 "Open Sans", sans-serif;
  left: 7px;
  top: 4px;
  content: "\02143";
  transform: rotate(40deg);
}

.leaflet-control-layers-selector:hover {
  background-color: #f7f7f7;
}

.leaflet-control-layers-selector:checked {
  background-color: #f1f1f1;
}

.leaflet-control-layers-base span {
  font: 12px/1.7 "Open Sans", sans-serif;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: pointer;
}

.leaflet-control-layers-separator {
  height: 0;
  border-top: 1px solid #ddd;
  margin: 15px -10px 0px -6px;
}

.leaflet-control-layers-list {
  margin-bottom: 10px;
}

/* PANEL DIRECCION */

#panelDireccion {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
}

.rowBtnSearchDireccion {
  padding: 10px 0px;
  text-align: center;
}

.el-scrollbar {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif !important;
}

/* CHECKBOX PANTALLA */
.el-checkbox__inner::after {
  height: 12px !important;
  left: 7px !important;
}

.el-checkbox__inner {
  border: 1px solid #c5cad6 !important;
  width: 20px !important;
  height: 20px !important;
}

/* ESTILO POPUP */
.leaflet-popup-content-wrapper {
  border-radius: 2px !important;
  text-align: center !important;
  padding: 5px;
}
</style>